import {
  AddUserToGroupAllSuccess,
  FailedToImportUsersFileResult,
  SucceedUserImport,
  UserRemoveFromGroupSuccess,
} from "../../../../../Application/services/realTimeNotification/events/people/peopleEvents";
import type ColumnOptions from "../../../../../../interfaces/columnOptions";

export const getCommonColumnOptions = (sortable: boolean): ColumnOptions[] => [
  {
    name: "Name",
    width: 4,
    isSortable: sortable,
  },
  {
    name: "Department",
    width: 3,
    isSortable: sortable,
  },
  {
    name: "Job title",
    width: 3,
    isSortable: sortable,
  },
];

export const columnOptionsAutoEnroll: ColumnOptions[] = [
  ...getCommonColumnOptions(false),
  {
    name: "Added",
    width: 3,
    isSortable: false,
  },
];

export const columnOptionsManualEnroll: ColumnOptions[] = [
  ...getCommonColumnOptions(true),
  {
    name: "Added",
    width: 3,
    isSortable: true,
  },
  {
    name: "",
    width: 1,
    isSortable: false,
  },
];

export const membersListViewRtnEvents = [
  AddUserToGroupAllSuccess,
  UserRemoveFromGroupSuccess,
  SucceedUserImport,
  FailedToImportUsersFileResult,
];
